import type { UserTenant } from "../types";

/** Label for the closed org select — organization name or tenant id, never user/member name. */
export function formatSelectedOrgLabel(
  tenantId: string | null | undefined,
  tenants: UserTenant[],
): string {
  if (!tenantId) return "Select organization";

  const tenant = tenants.find((entry) => entry.tenantId === tenantId);
  const orgName = tenant?.displayName?.trim();

  if (orgName && orgName !== tenantId && !orgName.includes("@")) {
    return orgName;
  }

  return tenantId;
}

export function formatOrgMenuPrimary(tenant: UserTenant): string {
  const orgName = tenant.displayName?.trim();
  if (orgName && orgName !== tenant.tenantId && !orgName.includes("@")) {
    return orgName;
  }
  return tenant.tenantId;
}

export function formatOrgMenuSecondary(tenant: UserTenant): string | null {
  const primary = formatOrgMenuPrimary(tenant);
  return primary !== tenant.tenantId ? tenant.tenantId : null;
}
